module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "ded"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("There can be no other dedication: To the men and women of the U.S. military, for all the reasons we know and all the reasons we will never know.")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "ded1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("And to Kayla, Blake, Lane, and Hailey. You bless my life with untold riches.")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51d39b50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ded.vue
// module id = 72
// module chunks = 0